/*
 * The sidebar's own write: the private half of a membership row (protocol.md §3.2,
 * `PATCH /api/chat/conversations/{id}/self`). Star, mute, notification level, hidden and the sort
 * hint are all one route and one action, which is why they are one function here and five entries in
 * the row's menu.
 *
 * The answer is the fresh row, and the server also emits `chat.membership.self` to this person's
 * own connections — so the model is updated by the event and never by the caller of this file. A
 * surface that wrote the answer into the store as well would paint the change twice and, on a slow
 * socket, in the wrong order.
 */

import { api } from "../../../core/net/api.ts"
import type { ConversationId } from "../../../core/store/model.ts"
import type { MemberSelf, SelfResponse, UpdateSelf } from "../wire/chat.gen.ts"

/**
 * What "muted" means when a person asks for it without naming a moment: the product offers Mute and
 * Unmute and no duration (Slack's menu offers durations; a seven-person team does not need them), so
 * a mute is until it is taken back. The column is a timestamp, so the value is one far enough away
 * that nobody will reach it — and an unmute is the same field at zero.
 */
export const MUTED_UNTIL_FURTHER_NOTICE = Date.UTC(2200, 0, 1)

export function updateSelf(conv: ConversationId, patch: UpdateSelf): Promise<MemberSelf> {
	return api
		.patch<SelfResponse>(`/api/chat/conversations/${conv}/self`, patch)
		.then((answer) => answer.self)
}
